<template>
  <section class="container">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          placeholder="请选择项目"
          @change="getDeviceList"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="机器类型">
        <a-radio-group @change="getDeviceList" v-model="form.version">
          <a-radio :value="1">一代机</a-radio>
          <a-radio :value="2">二代机</a-radio>
          <a-radio :value="3">三代机</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="热销类型">
        <a-radio-group @change="getDeviceList" v-model="form.sale_type">
          <a-radio :value="1">热销</a-radio>
          <a-radio :value="2">非热销</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="网点设备" prop="device_ids" ref="device_ids">
        <a-select
          showSearch
          :filterOption="filterOption"
          mode="multiple"
          optionFilterProp="children"
          style="width:300px"
          placeholder="请选择网点设备"
          v-model="form.device_ids"
          @change="selectedAisle"
        >
          <a-select-option
            v-for="(item, i) in deviceList"
            :key="i"
            :value="item.device_id"
            >{{ item.device_name }}</a-select-option
          >
        </a-select>
        <span style="margin-left:10px;display:inline-block">
          <a-checkbox :checked="checked" @change="selectedAll">全选</a-checkbox>
        </span>
      </a-form-model-item>
      <a-form-model-item label="货道商品">
        <table>
          <thead>
            <th>货道号</th>
            <th>商品名称</th>
          </thead>
          <tbody>
            <tr
              v-show="aisleList.length > 0"
              v-for="(item, key) in aisleList"
              :key="key"
            >
              <td>{{ item.aisle }}</td>
              <td>
                <a-select
                  style="width:200px"
                  showSearch
                  :filterOption="filterOption"
                  optionFilterProp="children"
                  placeholder="请选择商品"
                  v-model="item.brand_id"
                >
                  <a-select-option
                    v-for="(item, i) in goodsList"
                    :key="i"
                    :value="item.id"
                    >{{ item.brand_name }}</a-select-option
                  >
                </a-select>
              </td>
            </tr>
            <tr class="noData" v-show="aisleList.length == 0">
              <td>暂无</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button style="margin-right: 10px;" @click="resetForm">
          重置
        </a-button>
        <a-button type="primary" @click="onSubmit">
          确认
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </section>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        project_id: "",
        version: "",
        sale_type: "",
        device_ids: []
      },
      proList: [],
      deviceList: [],
      aisleList: [],
      goodsList: [],
      checked: false,
      rules: {
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        device_ids: [
          {
            required: true,
            message: "请选择网点设备",
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    this.getPro();
    this.getGoods();
  },
  methods: {
    getGoods() {
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Brand/getBrandList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.goodsList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    selectedAll(e) {
      this.checked = e.target.checked;
      this.form.device_ids = [];
      if (e.target.checked) {
        this.deviceList.forEach(element => {
          if (this.form.device_ids.indexOf(element.device_id) == -1) {
            // console.log(element.id)
            this.form.device_ids.push(element.device_id);
          }
          // console.log(element)
        });
      } else {
        this.form.device_ids = [];
      }
      this.selectedAisle();
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getDeviceList() {
      this.form.device_ids = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/getListData";
      let params = {
        project_id: this.form.project_id,
        sale_type: this.form.sale_type,
        version: this.form.version,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          this.deviceList = res.data.data;
          // console.log(this.deviceList);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    selectedAisle() {
      this.aisleList = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_brand_relation/getSameDeviceAisle";
      let params = {
        device_ids: JSON.stringify(this.form.device_ids),
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          if (res.data.data != "") {
            res.data.data.forEach(element => {
              this.aisleList.push({
                aisle: element,
                brand_id: ""
              });
            });
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    verify() {
      let fls = true;
      if (this.aisleList != "") {
        this.aisleList.forEach(element => {
          if (element.brand_id == "") {
            fls = false;
          }
        });
      }
      if (!fls) {
        this.$message.error("请选择货道商品");
      }
      return fls;
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Device_brand_relation/changedevicegoods";
          let fls = this.verify();
          if (fls) {
            let params = {
              token: window.localStorage.getItem("xnwfPcToken"),
              aisle_ids: JSON.stringify(this.aisleList),
              device_ids: JSON.stringify(this.form.device_ids)
            };
            axios.post(url, params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInChangeAisle", true);
              } else {
                this.$message.error(res.data.message);
              }
            });
            console.log(params);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.selectedAisle();
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;

  table {
    width: 60%;
    td,
    th {
      text-align: left;
      padding: 0 10px;
      border: 1px solid #ccc;

      img {
        height: 30px;
        width: 30px;
      }
    }
    th {
      background: #ededed;
    }
    .noData {
      border: 1px solid #ccc;

      td {
        border: none;
      }
    }
  }
}
</style>
